<template>
  <div class="apply-detail-page">
    <h1>收件信息</h1>
    <van-cell-group>
      <div class="block">
        <div class="title">收件人</div>
        <div class="con">{{detailInfo.Recipient}}</div>
      </div>
      <div class="block">
        <div class="title">收件手机</div>
        <div class="con">{{detailInfo.ReceivePhone}}</div>
      </div>
      <div class="block">
        <div class="title">省市区</div>
        <div class="con">{{detailInfo.ProvinceName}}{{detailInfo.CityName}}{{detailInfo.RegionName}}</div>
      </div>
      <div class="block">
        <div class="title">详细地址</div>
        <div class="con">{{detailInfo.FullAddress}}</div>
      </div>
    </van-cell-group>
    <h1>快递信息</h1>
    <van-cell-group>
      <div class="block">
        <div class="title">申请状态</div>
        <div class="con">{{detailInfo.ProcessStatus|ProcessStatusFilter}}</div>
      </div>
      <div class="block">
        <div class="title">快递单号</div>
        <div class="con">{{detailInfo.ExpressNo}}</div>
      </div>
    </van-cell-group>
  </div>
</template>
<script>
import { Toast, Dialog } from 'vant';
export default {
  data () {
    return {
      detailInfo: {},
    }
  },
  filters: {
    ProcessStatusFilter (status) {
      const statusMap = {
        0: '待处理',
        1: '发货处理中',
        2: '发货处理完成'
      }
      return statusMap[status]
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$Request({
        AppID: this.GLOBAL.AppID,
        Method: 'GetLoanOrthodonticLocateApplyForm',
      }).then(res => {
        this.detailInfo = res.FormData
      })
    },
  },
}
</script>
<style lang="less" scoped>
.apply-detail-page {
  font-size: 28px;
  color: @hGray;
  padding: 20px;
  h1 {
    font-size: 32px;
    color: #000;
    margin: 20px 0;
    font-weight: bolder;
  }
  .block {
    border-bottom: 1px solid #f1f1f1;
    display: flex;
    justify-content: center;
    line-height: 1.5;
    padding: 20px 0;
    .title {
      width: 200px;
      color: #333333;
      text-align: left;
    }
    .con {
      width: calc(100% - 200px);
      color: #aaaaaa;
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/member/apply-detail-locate.vue